import type ILabelsConfig from '@sravni/vitrina/lib/types/config/ILabelsConfig';
import type IProduct from '@sravni/vitrina/lib/types/IProduct';

export const findLabelsConfig = (config: ILabelsConfig[], product: IProduct): ILabelsConfig =>
  config?.find(({ productId, organizationId }) =>
    productId ? productId === product.id : organizationId === product.organization.id,
  );
